import * as R from "ramda";

export const getName = R.prop("name");
export const getID = R.prop("id");
export const getPhone = R.prop("phone");
export const getAddress = R.prop("address");
